/* eslint-disable jsdoc/require-jsdoc */
import { summaryAPIProps } from '../constants/telosair-interfaces';
import * as dashboardService from './dashboard-service';
import * as publicApiService from './public-api.service';

/**
 * Checks if the current session is a public view.
 * @returns True if public view, false otherwise.
 */
const isPublicView = (): boolean => {
  return sessionStorage.getItem('isPublicView') === 'true';
};

/**
 * Unified getDeviceSummaryOverTime that automatically uses the correct service.
 * @param payload - API payload.
 * @param options - Optional config.
 * @param options.signal - AbortSignal to cancel the request.
 * @returns Response data.
 */
export const getDeviceSummaryOverTime = (
  payload: summaryAPIProps & { devices?: number[] },
  options?: { signal?: AbortSignal }
): Promise<import('axios').AxiosResponse<any, any>> => {
  if (isPublicView()) {
    return publicApiService.getDeviceSummaryOverTime(payload, options);
  }
  return dashboardService.getDeviceSummaryOverTime(payload, options);
};

/**
 * Unified getMinAndMaxOfParameters that automatically uses the correct service.
 * @param payload - API payload.
 * @returns Response data.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getMinAndMaxOfParameters = (payload: summaryAPIProps & { devices?: number[] }) => {
  if (isPublicView()) {
    // Public API doesn't have min/max, return empty data
    return Promise.resolve({ data: [] });
  }
  return dashboardService.getMinAndMaxOfParameters(payload);
};
